import { createTheme, Theme, type ThemeOptions } from '@mui/material';

import { paletteTheme as baseTheme } from './foundations/palette';
import { paletteTheme as mvpBaseTheme } from './foundations/palette.mvp';
import { paletteTheme as dentaquestBaseTheme } from './foundations/palette.dentaquest';
import { paletteTheme as ahcBaseTheme } from './foundations/palette.ahc';
import { paletteTheme as ahcadminBaseTheme } from './foundations/palette.ahcadmin';
import { paletteTheme as transportBaseTheme } from './foundations/palette.transport';
import { typography } from './foundations/typography';
import { components } from './foundations/components';

// Layout constants
export const LAYOUT_CONSTANTS = {
  HEADER_HEIGHT: 8,
  FOOTER_HEIGHT: 20.125,
  MAX_CONTENT_WIDTH: 204,
  CONTENT_PADDING: 6,
  SIDEBAR_WIDTH: 30.5,
} as const;

const additionalThemeOptions: ThemeOptions = {
  typography: typography,
  components: components,
};

const getTheme = (portalName: string | null): Theme => {
  let paletteTheme = baseTheme;
  switch (portalName) {
    case 'mvp':
      paletteTheme = mvpBaseTheme;
      break;
    case 'dentaquest':
      paletteTheme = dentaquestBaseTheme;
      break;
    case 'ahc':
      paletteTheme = ahcBaseTheme;
      break;
    case 'ahcadmin':
      paletteTheme = ahcadminBaseTheme;
      break;
    case 'transport':
      paletteTheme = transportBaseTheme;
      break;
  }
  return createTheme(paletteTheme, additionalThemeOptions);
};

export { getTheme };
